import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  ogImage = 'https://cdn.gamma.app/8ez3v3g1znwt914/63ced91bcda94dbe90b2ed17da04cee0/optimized/tempImageymYGEQ.jpg',
  path = '/'
}) => {
  const siteUrl = 'https://luxury-homes-ohio.preview.emergentagent.com';
  const fullUrl = `${siteUrl}${path}`;
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />
      
      {/* Additional Meta Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="author" content="EC Home Builds" />
      <meta name="geo.region" content="US-OH" />
      <meta name="geo.placename" content="Columbus, Ohio" />
    </Helmet>
  );
};

export default SEO;
